import { gql } from '@apollo/client';

export const GET_IMPORT_STATUS = gql`
    query GetImportLogs($id: String!) {
        getManualImportLogById(id: $id) {
            id
            status
            error
            recordsProcessed
            startedAt
            completedAt
            metadata
        }
    }
`;
